import { useEffect, useState } from "react";
import { useAcoes, useEstado, useOcupado } from "../estado.jsx";
import { useNavegacao } from "../navegacao.jsx";
import * as api from "../api.js";
import { Botao, Cortina, Escolha, SeloIA } from "../componentes/comuns.jsx";

/*
 * Quem atende ESTE cliente — duas perguntas, em palavras de quem atende (02/11).
 *
 * A versão anterior tinha "herdar", três modos e doze agentes na mesma caixa,
 * e o Felipe não entendeu. Agora: 1) a equipe ou um agente de recepção; 2) se
 * for agente, se ele responde sozinho (Piloto) ou escreve para alguém aprovar
 * (Copiloto). Os agentes de etapa (Triagem, Contrato…) não aparecem aqui:
 * entram sozinhos no momento deles, configurados em IA do atendimento.
 * Copiloto e Piloto são sempre de um agente — nunca IA genérica.
 */
const EQUIPE = "equipe";

const SOZINHO = [
  {
    id: "piloto",
    titulo: "Sim, responde sozinho",
    detalhe: "Para e chama a equipe se o cliente pedir uma pessoa ou se tiver dúvida.",
  },
  { id: "copiloto", titulo: "Não, alguém aprova", detalhe: "Ele escreve a resposta e alguém da equipe confirma antes de sair." },
];

export default function ModalDelegar() {
  const { caso } = useEstado();
  const ocupado = useOcupado();
  const { escolherModoDoCaso } = useAcoes();
  const nav = useNavegacao();
  const fechar = () => nav.ajustar({ delegar: null });
  const modoAtual = caso?.registro?.modo_ia ?? null;
  const comAgente = modoAtual === "copiloto" || modoAtual === "piloto";
  const agenteAtual = comAgente ? (caso?.delegacao?.agente_id ?? null) : null;
  const [quem, setQuem] = useState(agenteAtual ? String(agenteAtual) : EQUIPE);
  const [modo, setModo] = useState(modoAtual === "copiloto" ? "copiloto" : "piloto");
  const [setor, setSetor] = useState(null);
  const [agentes, setAgentes] = useState([]);
  useEffect(() => {
    let vivo = true;
    api
      .modoDaIA()
      .then((r) => vivo && setSetor(r))
      .catch(() => null);
    /* Só a recepção ligada: é ela que continua uma conversa do ponto em que
       estava (o lead que veio do LiderHub no meio do roteiro). */
    api
      .agentesIa()
      .then((r) => vivo && setAgentes((r.agentes ?? []).filter((a) => a.ativo && a.recepcao)))
      .catch(() => null);
    return () => {
      vivo = false;
    };
  }, []);

  const opcoes = [
    { id: EQUIPE, titulo: "A equipe", detalhe: "Uma pessoa do escritório responde. A IA não fala com o cliente." },
    ...agentes.map((a) => ({
      id: String(a.id),
      titulo: `${a.emoji} ${a.nome}`,
      detalhe: `Continua a conversa de onde parou e, no fim, passa o cliente${a.responsavel ? ` para ${a.responsavel}` : " para a equipe"}.`,
    })),
  ];
  const agente = agentes.find((a) => String(a.id) === quem) ?? null;
  const mudou = agente ? !(String(agenteAtual) === quem && modoAtual === modo) : comAgente;

  /* "A equipe": se o setor já é Sem IA, o caso volta a seguir o setor (nada a
     gravar no caso); senão, o caso fica Sem IA por conta própria. */
  const aplicar = () =>
    agente ? escolherModoDoCaso(modo, agente.id) : escolherModoDoCaso(setor?.modo === "sem_ia" ? null : "sem_ia");

  return (
    <Cortina
      aoFechar={fechar}
      antesDoTitulo={<SeloIA tamanho={20} fonte={9.5} />}
      titulo="Quem atende este cliente"
      rodape={
        <Botao
          rotulo="Aplicar"
          aoTocar={aplicar}
          desabilitado={!mudou || ocupado === "delegar"}
          destaque
          largo
          classe="min-w-[150px] rounded-xl bg-verde p-[13px] text-corpo hover:bg-verde/85"
        />
      }
    >
      <Escolha rotulo="Quem atende este cliente" valor={quem} aoEscolher={setQuem} opcoes={opcoes} />
      {agente ? (
        <>
          <h3 className="m-0 mt-5 mb-2 text-corpo font-semibold">O agente pode responder sozinho?</h3>
          <Escolha rotulo="O agente pode responder sozinho?" valor={modo} aoEscolher={setModo} opcoes={SOZINHO} />
        </>
      ) : null}
    </Cortina>
  );
}
